<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4jguBZ/Images/GC4BcovES.jpg?1684305843668" alt="This image is the cover for the book Acordes de guitarra para principiantes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Acordes de guitarra para principiantes
      </h1>
      <p class="bookDescription body article font2">
        <i>"Es un libro muy completo que contiene acordes de las etapas iniciales y posteriores. Todo está muy bien explicado. Se lo recomiendo a cualquiera que esté empezando con la guitarra". </i><b> Nigel Elliott, Guitarrista y Tutor (Irlanda del Norte)</b><br/> <br/> <b>Acordes de guitarra para principiantes</b> contiene 65 acordes diferentes arreglados en digitaciones fáciles.<br/> <br/> <b>- Technique</b><br/> <br/> La técnica de la mano del diapasón para tocar los acordes de la guitarra se analiza en detalle con diagramas. Cuando es necesario, algunos acordes se enseñan de forma gradual porque hacer sólo los aspectos más difíciles de la digitación de un acorde primero, permite que la mano sea más libre de ajustarse. Otros acordes se muestran con diferentes digitaciones para que puedas elegir el que prefieras. Tocar los acordes de guitarra puede parecer una contorsión para las manos del principiante, por eso hay una guía básica sobre cómo estirarlas para mantener las manos flexibles.<br/> <br/> <b>- Audio y más</b><br/> <br/> Cada acorde de guitarra tiene un ejemplo de audio descargable que te permite escuchar si lo has tocado bien, o escuchar lo que necesitas mejorar. Hay una introducción a los acordes de potencia y a los acordes de cejilla, en los que los acordes de cejilla se muestran como versiones más sencillas de las formas de los acordes de cejilla completa. En la parte posterior de Acordes de guitarra para principiantes hay una lista de canciones sugeridas que contienen acordes del libro.<br/> <br/> <b>¡Consigue tu copia hoy!</b><br/> <br/> <i>"Se ve muy bien. Me gustan especialmente las diferentes formas de tocar el acorde de A. Los ejercicios de calentamiento para la flexibilidad también son buenos. Es bueno que los acordes de cejilla se muestren como versiones parciales para hacerlos inicialmente más fáciles, y los principiantes pueden encontrar más aspectos interesantes cerca de la parte posterior del libro, donde se muestran versiones abiertas fáciles de otros acordes más exóticos, como Dm(maj7), el acorde de "James Bond"".</i><b> Campbell Murray, RGT &amp; MU Tutor Registrado (Escocia)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gareth Evans
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Intuition Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c313d4a